module.exports = __webpack_public_path__ + "static/media/MarinaCiavatta.1580d493.JPG";